// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PlusBadge":"beo_a bia_rj bia_rk bia_vh bia_eb bia_vf bia_gs bia_kh"};